import { mockAutomatedCampaigns } from './mock-data';
// TODO: Replace with actual API call when backend is ready
// const { data: campaigns, isLoading } = useApiQuery({
//   endpoint: AutomatedEndpoints.AutomatedCampaignsQuery,
//   payload: {
//     ownerType: viewerIdAndKind?.kind,
//     ownerId: viewerIdAndKind?.id,
//   },
//   options: {
//     enabled: !!viewerIdAndKind,
//   },
// });
export var useAutomatedCampaigns = function () {
    // TODO: Mock data - replace with actual API call
    var campaigns = mockAutomatedCampaigns;
    var isLoading = false;
    return {
        campaigns: campaigns,
        isLoading: isLoading,
        count: campaigns.length,
    };
};
